import React from 'react';
import { normDateToShortAmericanDate } from '@insurancemenu/imenu-components-lib/dist/helpers/dateFormatters';
import { useQueryParams } from 'global/hooks/useQuery';
import { observer } from 'mobx-react-lite';
import { useRootStore } from 'store/rootStore';
import { toJS } from 'mobx';
import { useHistory } from 'react-router-dom';
import HeaderWithBcBlock from 'components/common/headers/HeaderWithBcBlock';
import { INITIAL_FILTER } from 'store/ui-stores/browsing/browsingFilterStore';

interface HelpMeDecideContentProps {
  formContent: JSX.Element;
}

const HelpMeDecideContent = observer(({ formContent }: HelpMeDecideContentProps): JSX.Element => {
  const history = useHistory();
  //  Query params
  const query = useQueryParams();
  const cartId = query.get('cartId') || null;
  const pLineId = query.get('productLineId') || null;
  const groupId = query.get('groupId') || null;

  // Mobx store
  const {
    helpMeDecideStore: { setCriteriaIndex },
    browsingStore: { cart },
    browsingFilterStore: { setFilters },
  } = useRootStore();

  const {
    lastUpdateBrowsingCriteria: { effectiveDate, zipCode },
  } = toJS(cart);

  const bcText =
    effectiveDate && zipCode
      ? `Effective date: ${effectiveDate ? normDateToShortAmericanDate(effectiveDate) : ''}, Zip: ${zipCode}`
      : '';

  const onRedirect = (): void => {
    // Set first criteria for help me decide flow and reset filters
    setCriteriaIndex(1);
    setFilters(INITIAL_FILTER);
    if (cartId && pLineId && groupId) {
      history.push(`/popular-plans?cartId=${cartId}&productLineId=${pLineId}&groupId=${groupId}&cartType=popular`);
    } else {
      history.goBack();
    }
  };

  return (
    <div>
      <HeaderWithBcBlock
        title="Help Me Decide"
        backButtonText="Back to popular plans"
        bcBlockText={bcText}
        onRedirect={onRedirect}
      />
      {formContent}
    </div>
  );
});

export default HelpMeDecideContent;
